<template>
  <bizgain-component-layout
    :col-width="{ 'mx-5 px-4': !$vuetify.breakpoint.xsOnly, 'mx-2': $vuetify.breakpoint.xsOnly }"
    :is-content-top="true"
    :is-next-btn-enabled="true"
    view-port-height="170px"
  >
    <template v-slot:heading>
      {{ $t('message.bizgainOnboarding.selectObjectiveHeadline') }}
    </template>
    <template v-slot:sub-heading>
      <span :class="{'pl-1': !$vuetify.breakpoint.xsOnly}"> {{ $t('message.bizgainOnboarding.selectObjectiveSubHeadline') }} </span>
    </template>
    <template v-slot:content>
      <v-flex pb-3>
        <image-card-row
          :col-width="shrink ? 'xs4 md3 grow' : 'xs6 md3 grow'"
          :custom-style="{'min-width': '135px'}"
          :card-height="cardHeight"
          :objects="Object.fromEntries(Object.entries(objectiveType).filter(([_, value]) => value.id != 1) )"
          :select-card-id="selectedObjectiveId"
          @selected-card="setObjective"
          :class="['select-objective', { 'scrollable-row':shrink, 'mt-2': !$vuetify.breakpoint.xsOnly} ]"
          :shrink="shrink"
          :img-width="imageWidthAndHeight"
          :img-height="imageWidthAndHeight"
          :is-card-selectable="!disableSelectObjective"
        >
          <template v-slot:title="objectiveTitle">
            {{ $t(objectiveTitle.title) }}
          </template>
        </image-card-row>
        <div v-if="selectedObjectiveId == objectiveType.calls.id">
          <v-flex
            xs12
            sm6
            mt-2
            mb-3
          >
            <div class="label">
              {{ $t('message.campaignLaunch.phoneNumber') }}
            </div>
            <vue-tel-input
              :dropdown-options="getDropdownOptions()"
              :input-options="getInputOptions()"
              :invalid-msg="$t('message.bizgainOnboarding.mobileNumberValidationMessage')"
              :value="mobileNumber"
              :valid-characters-only="true"
              mode="national"
              @validate="setPhoneNumber"
            />
          </v-flex>
          <v-flex xs12>
            <div class="label">
              {{ $t('message.bizgainOnboarding.getCallsOn') }}
            </div>
            <opening-hours :call-hours="callHours" @callHoursUpdate="setCallHours" />
          </v-flex>
        </div>
        <div v-if="selectedObjectiveId == objectiveType.leadGeneration.id">
          <v-flex xs12 mt-2>
            <div class="label">
              {{ $t('message.bizgainOnboarding.leadFormFieldSelectionMessage') }}
            </div>
            <lead-form-fields :prefilled-fields="formFields" @formFieldsUpdate="setFormFields" />
          </v-flex>
        </div>
        <div v-if="selectedObjectiveId == objectiveType.websiteVisits.id">
          <v-flex xs12 sm8 mt-2>
            <div class="label">
              {{ $t('message.bizgainOnboarding.websiteVisitHeading') }}
            </div>
            <v-text-field
              type="url"
              v-model="websiteVisitDestinationUrl"
              placeholder="Ex: https://yourwebsite.com"
              name="websiteVisitLink"
              class="py-0 ma-0"
              v-validate="'required|url'"
              data-vv-validate-on="blur"
              @focus="clearErrorByField($event, 'websiteVisitLink')"
              :error-messages="
                errors.first('websiteVisitLink')
                  ? $t(
                    'message.bizgainOnboarding.websiteUrlValidationMessage'
                  )
                  : null
              "
            />
          </v-flex>
          <alert
            :type="'primary'"
            :icon-color="'primary'"
            :icon-width="`${ !$vuetify.breakpoint.smAndDown ? 'xs1' : 'xs2' }`"
            :outline="true"
            :outline-color="'primary'"
            :message="$t('message.bizgainOnboarding.websiteVisitAlertMessage')"
            :col-width="'xs12 sm9'"
          />
        </div>
        <div v-if="selectedObjectiveId == objectiveType.instantMessages.id">
          <v-flex xs12 sm8 mt-2>
            <div class="label">
              {{ $t('message.bizgainOnboarding.instantMessagesSelectorTitle') }}
            </div>
          </v-flex>
          <v-flex xs12 sm8 mt-2>
            <v-checkbox
              v-model="selectedAppsForInstantMessages"
              color="primary"
              class="black--text"
              :value="messengerDestination"
              :ripple="false"
            >
              <template v-slot:label>
                <v-img :src="fbMessengerIcon" width="25px" />
                <span class="ml-1">Facebook Messenger</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="selectedAppsForInstantMessages"
              color="primary"
              class="black--text"
              :value="instagramDirectDestination"
              :ripple="false"
            >
              <template v-slot:label>
                <v-img :src="instagramIcon" width="25px" />
                <span class="ml-1">Instagram</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="selectedAppsForInstantMessages"
              color="primary"
              class="black--text"
              :value="whatsappDestination"
              :ripple="false"
            >
              <template v-slot:label>
                <v-img :src="whatsAppIcon" width="25px" />
                <span class="ml-1">Whatsapp</span>
              </template>
            </v-checkbox>
          </v-flex>
        </div>
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12>
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'xs2 nxt-btn-margin': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :loading="isUpdateSelectedObjective"
              :disabled="isNextButtonDisabled"
              @click="updateObjective"
            >
              {{ $t('message.bizgainOnboarding.next') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import { bizgainOnboardingImage, bizgainConfig, objectiveType, bizgainOnboardingRoutes, launchState, onboardingSections, subsequentFlowSteps, leadFormEnabledFields, fallbackCountryCode, instantMessageDestinationApps } from 'Features/bizgainOnboarding/constants';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import ImageCardRow from 'Components/ImageCardRow/ImageCardRow.vue';
import { mapActions, mapGetters } from 'vuex';
import { RoimaticService } from 'AppServices/roimaticService';
import { Chat } from 'Mixins/chat';
import { i18n } from '@/lang/';
import onboardingRedirect from 'Mixins/onboardingRedirect';
const apiService = new ApiService();
import clearErrorByField from 'Mixins/clearErrorByField';
import {
  VFlex,
  VTextField,
  VLayout,
  VBtn,
  VImg,
  VCheckbox
} from 'vuetify/lib';
import Alert from 'Components/Alert/Alert';
import OpeningHours from './OpeningHours.vue';
import LeadFormFields from './LeadFormFields.vue';
import Bugsnag from '@bugsnag/js';

export default {
  mixins: [clearErrorByField, Chat, onboardingRedirect],
  components: {
    BizgainComponentLayout,
    ImageCardRow,
    VFlex,
    VTextField,
    VLayout,
    OpeningHours,
    VBtn,
    Alert,
    LeadFormFields,
    VImg,
    VCheckbox
  },
  async created(){
    if (this.businessDetails){
      if (this.businessDetails.mobileNumber && this.businessDetails.mobileNumber.length > 0) {
        this.mobileNumber = this.businessDetails.mobileNumber;
      }
      else if (this.businessDetails.businessPhoneNumber && this.businessDetails.businessPhoneNumber.length > 0) {
        this.mobileNumber = this.businessDetails.businessPhoneNumber;
      }

      if(this.businessDetails.hasOwnProperty('callHours')){
        this.callHours = this.businessDetails.callHours;
      }

      if (this.businessDetails.hasOwnProperty('creativeDetail')){
        if (this.businessDetails.creativeDetail.objective){
          this.setObjective(this.businessDetails.creativeDetail.objective);
          if((this.businessDetails.creativeDetail.objective == objectiveType.instantMessages.id) && (this.businessDetails.creativeDetail.instantMessagesApps.length))
          {
            this.selectedAppsForInstantMessages = this.businessDetails.creativeDetail.instantMessagesApps;
          }
        }
        if (this.businessDetails.creativeDetail.hasOwnProperty('leadAdConfiguration') && this.businessDetails.creativeDetail.leadAdConfiguration.formFields.length > 0)
        {
          this.formFields = this.businessDetails.creativeDetail.leadAdConfiguration.formFields;
        }
      }

      if (this.businessDetails.websiteVisitDestinationUrl){
        this.websiteVisitDestinationUrl = this.businessDetails.websiteVisitDestinationUrl;
      }
      else if (this.businessDetails.websiteUrl){
        this.websiteVisitDestinationUrl = this.businessDetails.websiteUrl;
      }
    }

    if (!this.websiteVisitDestinationUrl){
      if (this.googlePlaceDetails && this.googlePlaceDetails.website) {
        this.websiteVisitDestinationUrl = this.googlePlaceDetails.website;
      }
      else if (this.facebookPageDetails && this.facebookPageDetails.website) {
        this.websiteVisitDestinationUrl = this.facebookPageDetails.website;
      }
    }

    if (this.businessLocation && this.businessLocation.countryCode){
      this.countryCode = this.businessLocation.countryCode;
    }
    else{
      // if countryCode is not available we're falling back to IN as countryCode
      this.countryCode = fallbackCountryCode;
    }

    this.setCurrentSection(onboardingSections.CREATIVE);
    if(this.isInAppCampaign){
      this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentSelectObjective.name);
      this.setSubsequentSteps(subsequentFlowSteps);
    }
    else{
      this.setCurrentRoute(bizgainOnboardingRoutes.SelectObjective.name);
    }
  },
  async mounted(){
    if(this.isInAppCampaign){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails))
      if(newBusinessDetails){
        newBusinessDetails.launchState = launchState.OBJECTIVE;
        let patchBusinessDetailsPayload = {
          sessionId: this.businessDetails.sessionId,
          oldBusinessDetails: this.businessDetails,
          newBusinessDetails: newBusinessDetails
        };
        await this.patchBusinessDetails(patchBusinessDetailsPayload);
        await apiService.updateRoimaticCampaign(this.businessProfileId, this.roimaticCampaignId, this.businessDetails.sessionId);
      }
    }
  },
  data() {
    return {
      objectiveType,
      bizgainOnboardingImage,
      selectedObjectiveId: null,
      newBusinessDetails: null,
      bizgainOnboardingRoutes,
      shrink: false,
      mobileNumber: '',
      phoneObject: null,
      countryCode: '',
      leadFormEnabledFields,
      callHours: null,
      isUpdateSelectedObjective: false,
      formFields: [],
      websiteVisitDestinationUrl: '',
      disableSelectObjective: false,
      instantMessageDestinationApps,
      messengerDestination: instantMessageDestinationApps.MESSENGER,
      instagramDirectDestination: instantMessageDestinationApps.INSTAGRAM_DIRECT,
      whatsappDestination: instantMessageDestinationApps.WHATSAPP,
      selectedAppsForInstantMessages: [instantMessageDestinationApps.MESSENGER],
      whatsAppIcon: bizgainConfig.whatsappIcon,
      instagramIcon: bizgainConfig.instagramSqIcon,
      fbMessengerIcon: bizgainConfig.fbMessengerIcon,
      roimaticService: null
    }
  },
  watch: {
    selectedObjectiveId() {
      this.scrollObjectiveRowToEnd();
    },
    shrink() {
      this.scrollObjectiveRowToEnd();
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'isError', 'isInAppCampaign', 'roimaticCampaignId', 'businessProfileId', 'googlePlaceDetails', 'facebookPageDetails', 'portalSupportNumber', 'roimaticConfiguration']),
    disableNext(){
      return !this.selectedObjectiveId;
    },
    imageWidthAndHeight(){
      if(this.shrink){
        return this.$vuetify.breakpoint.width < 500 ? '40' : '45';
      }
      else{
        return this.$vuetify.breakpoint.width < 500 ? '100' : '120';
      }
    },
    cardHeight(){
      if(this.shrink){
        if (this.$vuetify.breakpoint.xsOnly){
          return this.$vuetify.breakpoint.width <= 360 ? 115 : 94;
        }
        else if (this.$vuetify.breakpoint.smOnly && this.$vuetify.breakpoint.width < 750){
          return 108;
        }
        if (this.$vuetify.breakpoint.width > 1350){
          return 92;
        }
        return 98;
      }
      else{
        return this.$vuetify.breakpoint.width < 500 ? 176 : 196;
      }
    },
    isNextButtonDisabled()
    {
      return (this.disableNext || this.errors.items.length > 0 || ((this.selectedObjectiveId == this.objectiveType.calls.id) && (!this.phoneObject || !this.phoneObject.valid)) || ((this.selectedObjectiveId == this.objectiveType.instantMessages.id) && !this.selectedAppsForInstantMessages.length))
    }
  },
  methods: {
    ...mapActions(['setSubsequentSteps', 'setCurrentSection', 'setCurrentRoute', 'patchBusinessDetails', 'addCreativeLogo', 'addCreativeLeadImage', 'clearMessages', 'updateBusinessDetails']),
    async updateObjective () {
      let isValid = await this.$validator.validate();
      if (isValid && this.businessDetails){
        try {
          this.isUpdateSelectedObjective = true;
          let oldObjective = this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.objective;
          if(oldObjective && oldObjective != this.selectedObjectiveId){
            await this.resetCreativeAndTargetingDetails();
          }
          let updateObjectivePayload = {
            sessionId: this.businessDetails.sessionId,
            objective: this.selectedObjectiveId
          };
          this.clearMessages();
          let creativeDetail = await apiService.creativeConfiguration(updateObjectivePayload);
          if (creativeDetail) {
            this.businessDetails.creativeDetail = creativeDetail;
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if (this.newBusinessDetails && this.newBusinessDetails.creativeDetail) {
              this.newBusinessDetails.creativeDetail.objective = this.selectedObjectiveId;
              var selectedObjectiveType = null;
              if (this.selectedObjectiveId == objectiveType.calls.id){
                this.newBusinessDetails.mobileNumber = this.phoneObject.number;
                this.newBusinessDetails.callHours = this.callHours;
                selectedObjectiveType = i18n.tc(objectiveType.calls.conversionTitle);
                await this.updateUserProperties({ businessPhoneNumber: this.mobileNumber });
              }
              if (this.selectedObjectiveId == objectiveType.leadGeneration.id){
                if (this.formFields.length > 0){
                  this.newBusinessDetails.creativeDetail.leadAdConfiguration.formFields = this.formFields;
                }
                selectedObjectiveType = i18n.tc(objectiveType.leadGeneration.conversionTitle);
              }
              if (this.selectedObjectiveId == objectiveType.websiteVisits.id){
                this.newBusinessDetails.websiteVisitDestinationUrl = this.websiteVisitDestinationUrl;
                selectedObjectiveType = i18n.tc(objectiveType.websiteVisits.conversionTitle);
              }
              if(this.selectedObjectiveId == objectiveType.instantMessages.id)
              {
                this.newBusinessDetails.creativeDetail.instantMessagesApps = this.selectedAppsForInstantMessages;
                selectedObjectiveType = i18n.tc(objectiveType.instantMessages.conversionTitle);
              }
              await this.updateUserProperties({ objectiveType: selectedObjectiveType });
              await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, false, launchState.OFFER, this.newBusinessDetails);
              if(this.isError){
                this.isUpdateSelectedObjective = false;
              }
            }
          }
        } catch {
          this.isUpdateSelectedObjective = false;
        }
      }
    },
    isObjectiveTypeCall(objectiveId){
      return objectiveId === this.objectiveType.calls.id;
    },
    setObjective(objectiveId){
      this.selectedObjectiveId = objectiveId;
      this.shrink = true;
    },
    setPhoneNumber(value){
      this.phoneObject = value;
    },
    setCallHours(updateCallHours){
      this.callHours = updateCallHours;
    },
    setFormFields(selectedFields){
      this.formFields = selectedFields;
    },
    getDropdownOptions() {
      return {
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        tabindex: 0,
        width: '300px'
      }
    },
    getInputOptions() {
      return {
        autocomplete: 'on',
        autofocus: false,
        ariaDescribedby: '',
        id: '',
        maxlength: 25,
        name: 'telephone',
        showDialCode: false,
        placeholder: `Ex: ${this.portalSupportNumber}`,
        readonly: false,
        required: true,
        tabindex: 0,
        type: 'tel',
        styleClasses: ''
      }
    },
    scrollObjectiveRowToEnd()
    {
      if(this.shrink && (this.selectedObjectiveId == this.objectiveType.instantMessages.id))
      {
        setTimeout(function() {
          try
          {
            var scrollableRow = document.getElementsByClassName('select-objective')[0].getElementsByClassName('layout')[0];
            scrollableRow.scrollLeft = scrollableRow.scrollWidth;
          }
          catch
          {
            Bugsnag.notify('Failed to auto scroll the objective');
          }
        }, 100);
      }
    },
    async resetCreativeAndTargetingDetails(){
      let newBusinessDetails  = {
        businessProfileSearchEngineIds: this.businessDetails.businessProfileSearchEngineIds,
        claimedBpDetails: this.businessDetails.claimedBpDetails,
        category: this.businessDetails.category,
        callHours: this.businessDetails.callHours,
        currencySymbol: this.businessDetails.currencySymbol,
        facebookPageDetail: this.businessDetails.facebookPageDetail,
        gender: this.businessDetails.gender,
        googlePlaceDetail: this.businessDetails.googlePlaceDetail,
        googlePlaceId: this.businessDetails.googlePlaceId,
        isBusinessLogoAvailable: this.businessDetails.isBusinessLogoAvailable,
        isWhatsAppUpdatesOpted: this.businessDetails.isWhatsAppUpdatesOpted,
        keywords: this.businessDetails.keywords,
        launchState: this.businessDetails.launchState,
        location: this.businessDetails.location,
        logoDetails: this.businessDetails.logoDetails,
        name: this.businessDetails.name,
        openingHours: this.businessDetails.openingHours,
        pollingRequestDetails: this.businessDetails.pollingRequestDetails,
        queryParameters: this.businessDetails.queryParameters,
        razorpayIdempotencyKey: this.businessDetails.razorpayIdempotencyKey,
        region: this.businessDetails.region,
        sessionId: this.businessDetails.sessionId,
        suggestedCategories: this.businessDetails.suggestedCategories,
        suggestedServices: this.businessDetails.suggestedServices,
        services: this.businessDetails.services,
        unsplashLeadImage: this.businessDetails.unsplashLeadImage,
        uploadedImages: this.businessDetails.uploadedImages,
        website: this.businessDetails.website
      };
      let patchBusinessDetailsPayload = {
        sessionId: this.businessDetails.sessionId,
        oldBusinessDetails: this.businessDetails,
        newBusinessDetails: newBusinessDetails
      };
      await this.patchBusinessDetails(patchBusinessDetailsPayload);
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep.select-objective{
  .v-card__title {
    padding: 12px 16px;
  }
  .v-card__text {
    .flex {
      margin: 1px;
    }
  }
}

::v-deep .scrollable-row .layout {
  flex-wrap: nowrap !important;
  overflow: auto !important;
}

::v-deep .black--text {
  margin-bottom: 5px !important;
  margin-top: 0 !important;
  padding: 0 !important;
  label {
    color: black;
  }
  .v-messages {
    display: none;
  }
}

::v-deep .item-container-sm-1 {
  height: calc(var(--vh, 1vh) * 100 - 80px ) !important;
}

</style>